export default "__VITE_ASSET__oquK_1sL__"